// extracted by mini-css-extract-plugin
export default {"panel":"Editor_panel__bTClh","inputGroup":"Editor_inputGroup__f951S","textarea":"Editor_textarea__CPzUe","button":"Editor_button__N9aMr"};